







































































































































































































import {Component, Vue} from 'vue-property-decorator';
import CartHeader from '@/components/Cart/CartHeader.vue';
import CartFooter from '@/components/Cart/CartFooter.vue';
import CartItem from '@/components/Cart/Item.vue';
import CartTotals from '@/components/Cart/Totals.vue';
import ShippingFreeMessage from '@/components/Shipping/FreeMessage.vue';
import ShippingFreeTooltip from '@/components/Shipping/FreeTooltip.vue';
import ShippingTimesMessage from '@/components/Shipping/Times.vue';
import Coupon from '@/components/Cart/Coupon.vue';
import GiftCard from '@/components/Cart/GiftCard.vue';
import ShippingMethodSelection from '@/components/Cart/ShippingMethodSelection.vue';
import Loyalty from '@/components/Cart/Loyalty.vue';
import {CartItem as CartItemModel, QuoteAddress, ShippingMethod, Totals, TotalSegment} from '@/store/models';
import cart from '@/store/modules/cart';
import checkout from '@/store/modules/checkout';
import CmsBlock from '@/components/Cms/Block.vue';
import user from '@/store/modules/user';
import store from '@/store';
import gtmhelpers from '@/commons/gtmhelpers';
import {bus} from '@/events/bus';
import {Route} from 'vue-router';
import paidEvent from '@/events/paid';
import payment from '@/store/modules/payment';
import app from '@/store/modules/app';
import {i18n} from '@/i18n';
import handleError from '@/commons/errorHandler';
import {Mutation} from 'vuex-module-decorators';
import to from 'await-to-js';
import redirectToLocation from '@/commons/redirectManager';
import {displayCookieMessages, encodeCookie, setCookie} from '@/commons/cookies';
import axios from 'axios';
import {resetLocalStorageCart} from '@/commons/localStorage';
import AppBanner from '@/components/UI/AppBanner.vue';
import device from '@/store/modules/device';
import UserStep from '@/components/Checkout/UserStep.vue';
import StripHeader from '@/components/Checkout/StripHeader.vue';
import mse from '@adobe/magento-storefront-events-sdk';
import handleMessage from '@/commons/messageManager';
import { Account, Page } from '@adobe/magento-storefront-events-sdk/dist/types/types/schemas';

Component.registerHooks(['beforeRouteEnter']);

@Component({
    components: {
        CartHeader,
        CartFooter,
        CartItem,
        CartTotals,
        ShippingFreeMessage,
        ShippingFreeTooltip,
        ShippingTimesMessage,
        Coupon,
        GiftCard,
        ShippingMethodSelection,
        CmsBlock,
        AppBanner,
        UserStep,
        Loyalty,
        StripHeader,
    },
})
export default class Cart extends Vue {
    public cartHeaderInfoHeight = '0';
    private reorderIsLoading = false;

    get items(): CartItemModel[] {
        const itemsSortedBySku = cart.cart.items.sort((a, b) => a.sku.localeCompare(b.sku));

        return [
            ...itemsSortedBySku.filter(
                (i) => !i.extension_attributes.extis_salable || i.extension_attributes.extitem_error !== '',
            ),
            ...itemsSortedBySku.filter(
                (i) => i.extension_attributes.extis_salable && i.extension_attributes.extitem_error === '',
            ),
        ];
    }

    get isLogged(): boolean {
        return user.isLoggedin;
    }

    get count(): number {
        return cart.cart.items.length;
    }

    get totals(): Totals {
        return cart.totals;
    }

    get totalsIsLoading(): boolean {
        return cart.loadingFlags.totals;
    }

    get cartHasErrors(): boolean {
        return cart.cartHasError;
    }

    get cartLastOrderIdNotFinalized(): string {
        return ['payment_review', 'pending_payment_scalapay'].includes(checkout.lastOrder.status) &&
        !checkout.lastOrder.reorder_flag
            ? checkout.lastOrder.id
            : '';
    }

    get shippingAddress(): QuoteAddress {
        return checkout.shippingAddress;
    }

    get isValidSelection() {
        return checkout.selectedShipment && checkout.selectedShipment.toString() !== '';
    }

    get shippingMethods(): ShippingMethod[] {
        return checkout.shippingMethods;
    }

    get professionalDisclaimersCart(): string {
        return cart.professionalDisclaimers.messages.cart;
    }

    get isMobile() {
        return device.isMobile;
    }

    get isApp() {
        return app.isApp;
    }

    get countryNotSelected() {
        return checkout.shippingCountries.enabled && checkout.selectedShippingCountry === '';
    }

    get isShippingCountriesEnabled() {
        return checkout.shippingCountries.enabled;
    }

    get contactUsLink() {
        return store.state.options.contactUsLink;
    }

    private isProfessionalCheckDone(): boolean {
        return !cart.isProfessional;
    }

    private productsAllAvailable(): boolean {
        let itemsAreAvailable = true;

        if (cart.cart.items.length > 0) {
            cart.cart.items.forEach((item) => {
                if (!item.extension_attributes.extis_salable || item.extension_attributes.extitem_error !== '') {
                    itemsAreAvailable = false;
                }
            });
        }
        return itemsAreAvailable;
    }

    private isCouponVisibleOnCart() {
        return store.state.options.coupon.payment_step === 0;
    }

    private mounted() {
        displayCookieMessages();
        app.changeCartItemNumber();

        if (cart.isEmpty) {
            resetLocalStorageCart();
        } else {
            checkout.checkSingleShippingMethod(true);
        }

        gtmhelpers.trackPageview(this.$router.currentRoute.fullPath);

        device.updateMobileDetection();

        const page: Page = {
            pageType: 'Cart',
            maxXOffset: 0,
            maxYOffset: 0,
            minXOffset: 0,
            minYOffset: 0,
            ping_interval: 5,
            pings: 1,
        };
        mse.context.setPage(page);
        mse.context.setContext('pageExtended', { action: 'cart-view' });
        const account: Account = {
            firstName: user.customer.firstname,
            lastName: user.customer.lastname,
            emailAddress: user.customer.email,
        };
        mse.context.setAccount(account);
        mse.context.setShopper({ shopperId: user.isLoggedin ? 'logged-in' : 'guest' });

        // Update cartHeaderInfoHeight
        const cartHeaderInfo = this.$refs.cartHeaderInfo as HTMLElement;

        if (cartHeaderInfo) {
            this.cartHeaderInfoHeight = `${cartHeaderInfo.offsetHeight}px`;
        }
    }

    private goToCheckout() {
        if (!this.isValidSelection && !cart.isVirtual) {
            handleMessage('error', i18n.t('Select a shipping method to continue').toString());

            if (this.isMobile) {
                (this.$refs.cartGridSidebar as HTMLElement).scrollIntoView({
                    behavior: 'smooth',
                });
            }

            return;
        }

        this.$router.push({path: '/checkout/login'});
    }

    private beforeRouteEnter(routeTo: Route, routeFrom: Route, next: any): void {
        if (payment.paymentSuccessInfo.transaction_id || payment.paymentSuccessInfo.error_message) {
            if (payment.paymentSuccessInfo.transaction_id) {
                bus.$emit(paidEvent, {
                    useStoredData: true,
                    payData: {},
                    paymentMethod: '',
                    redirectUrl: '/checkout/onepage/success',
                });
            } else if (payment.paymentSuccessInfo.error_message) {
                handleMessage('error', payment.paymentSuccessInfo.error_message);
            }
        }

        next();
    }

    private redirectToHome() {
        if (app.isApp) {
            app.goToHome();
        } else {
            redirectToLocation('/');
        }
    }

    private reorderPost(orderId: string) {
        this.reorderIsLoading = true;
        axios
            .get(`${store.state.options.full_base_url}rest/V1/carts/mine/reorder/${orderId}`)
            .then((response) => {
                // If result is numeric, change cart item number
                // otherwise show error message
                if (/^\d+$/.test(response.data)) {
                    app.changeCartItemNumber(response.data);
                } else {
                    const errorMessage = [
                        {
                            type: 'error',
                            text: response.data,
                        },
                    ];
                    setCookie('mage-messages', encodeCookie(errorMessage), 0, '/');
                }

                // Reload checkout
                window.location.reload();
                this.updateMiniCart();
            })
            .catch(() => {
                handleMessage('error', i18n.t('Service unavailable, retry later').toString());
                this.reorderIsLoading = false;
            });
    }

    private created() {
        device.detectMobile();
    }

    private getShipping(totalSegments: TotalSegment[]) {
        const shippingTotal = totalSegments.find((total) => {
            return total.code === 'shipping';
        });

        return shippingTotal ? shippingTotal.value : 0;
    }

    private getGrandTotal(totalSegments: TotalSegment[]) {
        const grandTotal = totalSegments.find((total) => {
            return total.code === 'grand_total';
        });

        return grandTotal ? grandTotal.value : 0;
    }

    private updateMiniCart() {
        const mageCacheStorage = localStorage.getItem('mage-cache-storage');
        if (mageCacheStorage) {
            try {
                const mageCacheStorageObject = JSON.parse(mageCacheStorage);
                delete mageCacheStorageObject.cart;
                localStorage.setItem('mage-cache-storage', JSON.stringify(mageCacheStorageObject));
            } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
                handleError(e);
            }
        }
    }
}
